<template>
  <div class="goods-content">
    <div class="content-header">
      <div class="header-leftText">
        <h3 class="application-name">{{ appInfo.channelShowName }}</h3>
        <p class="application-desc">
          {{ appInfo.channelDes }}
        </p>
      </div>
      <img class="titleImg-h5" src="@/assets/images/bankeysH5-goodsImg.png" alt />
    </div>
    <div v-if="appInfo.mapProjectId" class="goods-detail">
      <div class="enhance-tip">升级提醒</div>
      <p class="goods-desc">
        尊敬的用户，天谷云CA已全新升级为e签盾移动CA，请点击“立即办理”前往开通。<br />
        如有疑问，您可以查看 <span @click="jumpToOperateDesc" class="operate-desc">《新用户开通操作手册》</span>
      </p>
      <div class="applyBtn" @click="jumpToApply">
        立即办理
      </div>
    </div>
    <div v-else class="goods-detail">
      <h4 class="goods-name">{{ goodsInfo.commodityName }}</h4>
      <p :class="{ 'goods-desc': true, mb: this.isResale }">
        {{
          !this.isResale
            ? 'e签盾可以帮助您通过手机完成电子签署，既安全又可靠。e签盾按照使用人数收费，每人消耗一份授权，每份授权有效期一年，每份授权价格如下：'
            : 'e签盾可以帮助您通过手机完成电子签署，既安全又可靠。e签盾按照使用人数收费，每人消耗一份授权，每份授权有效期一年，点击下方按钮即可申领。'
        }}
      </p>
      <div class="goods-price" v-if="!this.isResale">
        <span class="price-number"><i class="yuan-icon">￥</i>{{ goodsInfo.price }}</span
        >/{{ goodsInfo.unit }}
      </div>
      <div class="buyBtn" @click="buy">
        {{ !this.isResale ? '立即购买' : '立即申领' }}
      </div>
    </div>
    <createOrg
      :orgName="$route.query.orgName"
      :orgCode="$route.query.orgCode"
      :visible.sync="showCreateOrg"
      :source="source"
      @confirm="confirm"
      :isResale="this.isResale"
      v-if="showCreateOrg"
    />
    <confirm :visible.sync="showConfirm" />
  </div>
</template>

<script>
import realnameMixin from '@/mixins/realname.js'
import createOrg from './components/createOrg/CreateOrg.vue'
import confirm from './components/createOrg/Confirm.vue'
import { goLoginPage, isClient, isInEsignApp, getQueryStrings, queryParams } from '@/lib/utils'
import { mapState } from 'vuex'
import { encode, decode } from 'js-base64'
import { sourceChannel } from '@esign/esign-client-jssdk'

export default {
  components: { createOrg, confirm },
  mixins: [realnameMixin],
  props: {
    appInfo: {
      type: Object,
      default: () => ({}),
    },
    isResale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCreateOrg: false,
      showConfirm: false,
      goodsInfo: {},
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    source() {
      return {
        PlatformType: isInEsignApp() ? 'esignAPP' : isClient() ? 'H5' : 'WEB',
        ditchID: this.$route.query.ditchID || '',
      }
    },
  },
  created() {
    this.getGoodsInfo()
  },
  methods: {
    // 通过goodsId获取商品信息
    async getGoodsInfoByGoodsId(goodsId) {
      const { data } = await this.$Http.api({
        url: `webserver/v1/tcloud/product/commodities/${goodsId}/detail`,
        method: 'GET',
      })

      return data
    },

    // 获取渠道商品列表
    async getChannelList() {
      const { data } = await this.$Http.api({
        url: 'webserver/v1/showcases/{showcaseId}/commodities',
        method: 'GET',
        params: {
          showcaseId: 'qudao001',
        },
      })

      return data
    },

    // 获取购买的指定商品id
    async getGoodsId() {
      const { data } = await this.$Http.api({
        url: 'webserver/v1/cooperator/{channelGid}',
        method: 'GET',
        params: {
          channelGid: this.$route.query.ditchID,
        },
      })

      return data.showProductList[0]
    },

    // 获取商品详情
    async getGoodsInfo() {
      const {
        query: { commodityId, saleInfoId },
      } = this.$route
      if (commodityId) {
        const data = await this.getGoodsInfoByGoodsId(commodityId)
        this.goodsInfo = data
        const { saleType, packages, licenses, billingRules } = data
        const t = saleType === 1 ? packages : saleType === 2 ? billingRules : licenses
        const goodsArray = saleInfoId !== 'null' ? t.filter(item => item.id === Number(saleInfoId)) : t[0]
        this.goodsInfo.price = goodsArray[0].price
        this.goodsInfo.unit = goodsArray[0].units
        this.goodsInfo.goodsArray = goodsArray
        this.goodsInfo.commodityId = this.goodsInfo.id
      } else {
        const [list, id] = await Promise.all([this.getChannelList(), this.getGoodsId()])
        this.goodsInfo = list.find(goods => goods.commodityId === id)
        this.goodsInfo.price = this.goodsInfo.licenses[0].price
        this.goodsInfo.unit = this.goodsInfo.licenses[0].licenseUnit
        this.goodsInfo.goodsArray = this.goodsInfo.licenses
      }
      console.log(this.goodsInfo)
    },

    // 点击立即购买
    buy() {
      // 用户点击购买埋点
      this.trackBuy()

      // 若未登陆跳登陆
      if (!this.userInfo) return goLoginPage()

      // 若未实名，则提示去个人实名
      if (!this.userInfo.realnameStatus) return this.realnameConfirm('为了保障您的帐号安全，需要您先完成实名认证')

      // 获取用户输入的企业ouid
      this.showCreateOrg = true
    },

    // 创建企业点击确认
    async confirm(orgId) {
      console.log('this.goodsInfo-------confirm', this.goodsInfo)
      const resultPage = encodeURIComponent(`${window.location.origin}/landing/bankeys/result?orgId=${orgId}`)
      if (this.isResale) {
        this.handleResale(orgId)

        return
      }
      // 新领
      const business = {
        operatorOid: this.userInfo ? this.userInfo.ouid : '',
        commodityType: 1,
        actionSource: 9,
        channelGid: decode(this.$route.query.ditchID),
      }
      const params = getQueryStrings()
      if (params.businessId && params.bizId) {
        business.bizId = params.bizId
      }
      params.businessId = encode(JSON.stringify(business))
      let href = ''
      const source_channel = Number(this.$route.query.source_channel) || sourceChannel
      if (this.$route.query.commodityId) {
        href = `${process.env.VUE_APP_ORDER_URL}/MyOrder/comfirm?${queryParams(params)}&menuId=${
          this.goodsInfo.goodsArray[0].id
        }&ctype=1&organ=${orgId}&returnUrl=${resultPage}`
      } else {
        href = `${process.env.VUE_APP_ORDER_URL}/MyOrder/comfirm?${queryParams(params)}&commodityId=${this.goodsInfo.commodityId}&menuId=${
          this.goodsInfo.goodsArray[0].id
        }&ctype=1&organ=${orgId}&returnUrl=${resultPage}`
      }
      source_channel && (href += `&source_channel=${source_channel}`)
      try {
        await this.setMain(orgId)
        this.redirectToOrder(href)
      } finally {
        this.redirectToOrder(href)
      }
    },

    // 跳转订单页
    redirectToOrder(href) {
      window.location.href = href
    },
    async setMain(orgId) {
      await this.$Http.api({
        url: `webserver/v1/accounts/sys_accountId/setMainOrg`,
        method: 'PUT',
        body: {
          orgId,
        },
      })
    },
    /**
     * 1：点击购买按钮用户数
     * */
    trackBuy() {
      if (!this.userInfo) return
      try {
        this.$tsignData.track('esignSheild_landing_buy', {
          source: 'esign-sheild-isolate', // 渠道名称
          url: window.location.href,
          ouid: this.userInfo ? this.userInfo.ouid : '',
        })
      } catch (e) {
        console.log('trackBuy', e)
      }
    },
    // 处理转售
    async handleResale(orgId) {
      try {
        await this.$Http.api({
          url: 'account-webserver/v1/mix/mobileShield/channels/{channelGid}/channelResell',
          method: 'POST',
          body: {
            orgOid: orgId,
            commodityId: this.goodsInfo.commodityId,
            bizId: this.$route.query.bizId,
            businessId: encode(
              JSON.stringify({
                commodityType: 1,
                bizId: this.$route.query.bizId,
                actionSource: 9,
                channelGid: decode(this.$route.query.ditchID),
                operatorOid: this.userInfo.ouid,
                operatorName: this.userInfo.name,
              })
            ),
          },
          params: {
            channelGid: this.$route.query.ditchID,
          },
        })
        setTimeout(() => {
          this.showConfirm = true
        }, 500)
      } catch (e) {
        this.$dialog.toast({ icon: 'error', message: e.message, style: 'z-index: 100002' })
      } finally {
        this.showCreateOrg = false
      }
    },
    jumpToOperateDesc() {
      window.open('https://qianxiaoxia.yuque.com/docs/share/dea415d1-6160-4fc7-8ad1-fb7666db015b?#')
    },
    jumpToApply() {
      const url = `${process.env.VUE_APP_ZQB}/mobileShieldLanding?projectId=${this.appInfo.mapProjectId}`
      window.open(url)
    },
  },
}
</script>

<style lang="less" scoped>
.goods-content {
  width: 100%;
  min-height: calc(100% - 34px);
  position: relative;
  background: #f7f8fa;
  padding-bottom: 32px;
  .content-header {
    width: 100%;
    height: 330px;
    padding-top: 68px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background: url(../../assets/images/bankeysPC-goodsImg.png) 88% 10px no-repeat, linear-gradient(114deg, #161b26 0%, #191c29 100%);
    background-size: 380px auto;
    color: #fff;
    .header-leftText {
      width: 42.4%;
      margin: 0 0 182px 11.9%;
      .application-name {
        font-size: 30px;
        font-weight: 500;
        line-height: 42px;
        margin-bottom: 32px;
      }
      .application-desc {
        font-size: 16px;
        font-weight: 300;
        line-height: 28px;
        height: 84px;
      }
    }
    .titleImg-h5 {
      display: none;
    }
  }
  .goods-detail {
    padding-top: 20px;
    width: 87.5%;
    margin: -80px auto 0;
    padding-bottom: 44px;
    background: #fff;
    border-radius: 4px;
    text-align: center;
    .goods-img {
      width: 160px;
      margin-top: 45px;
      display: inline-block;
    }
    .goods-name {
      width: 65.9%;
      font-size: 22px;
      font-weight: 400;
      color: rgba(26, 26, 26, 1);
      line-height: 30px;
      margin: 40px auto 32px;
    }
    .enhance-tip {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #1a1a1a;
      line-height: 22px;
      margin: 40px auto 32px;
    }
    .goods-desc {
      width: 65.9%;
      font-size: 16px;
      font-weight: 300;
      color: rgba(77, 77, 77, 1);
      line-height: 30px;
      margin: 0 auto;
      .operate-desc {
        color: #007aff;
        cursor: pointer;
      }
    }
    .applyBtn {
      width: 120px;
      height: 40px;
      margin: 76px auto 0;
      background: #1063f1;
      border-radius: 2px;
      color: #fff;
      line-height: 40px;
      font-size: 14px;
      cursor: pointer;
    }
    .mb {
      margin-bottom: 60px;
    }
    .goods-price {
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      margin: 48px 0 60px;
      .price-number {
        font-size: 48px;
        font-weight: 600;
        color: rgba(231, 82, 69, 1);
        line-height: 33px;
        .yuan-icon {
          font-size: 24px;
          font-style: normal;
        }
      }
    }
    .buyBtn {
      width: 151px;
      height: 52px;
      line-height: 52px;
      border-radius: 26px;
      font-size: 18px;
      color: #fff;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      background: linear-gradient(225deg, rgba(255, 72, 92, 1) 0%, rgba(255, 115, 95, 1) 100%);
      box-shadow: 0px 2px 6px 0px rgba(145, 1, 1, 0.2);
      position: relative;
      &:hover,
      &:active {
        background: linear-gradient(225deg, rgba(255, 109, 125, 1) 0%, rgba(255, 156, 142, 1) 100%);
        box-shadow: 0px 2px 6px 0px rgba(145, 1, 1, 0.2);
      }
    }
  }
}
@media (max-width: 768px) {
  .goods-content {
    background: #fff;
    padding-bottom: 0;
    min-height: calc(100% - 41px);
    .content-header {
      padding: 0 24px 36px;
      height: auto;
      align-items: center;
      background: url('../../assets/images/bankeysH5-goodsBg.png') left top no-repeat;
      text-align: left;
      justify-content: space-between;
      .header-leftText {
        flex: 1;
        margin: 30px 0 24px;
        .application-name {
          font-size: 24px;
          margin: 0 auto 12px;
          line-height: 32px;
        }
        .application-desc {
          font-weight: 400;
          line-height: 24px;
          margin: 0 auto;
          height: auto;
        }
      }
      .titleImg-h5 {
        display: block;
        width: 101px;
        height: 135px;
        margin: 21px 0 0 6.4%;
      }
    }
    .goods-detail {
      box-shadow: 0px 1px 6px 0px rgba(1, 21, 87, 0.1);
      margin: -32px auto 24px;
      .goods-price {
        margin: 24px 0 32px;
      }
      .goods-img {
        width: 120px;
      }
      .goods-name {
        width: 90.7%;
        font-size: 18px;
        margin: 12px 0;
      }
      .goods-desc {
        width: 90.7%;
        font-size: 14px;
      }
      .buyBtn {
        &:hover {
          background: linear-gradient(225deg, rgba(255, 72, 92, 1) 0%, rgba(255, 115, 95, 1) 100%);
          box-shadow: 0px 2px 6px 0px rgba(145, 1, 1, 0.2);
        }
      }
    }
  }
}
</style>
